module.exports = __webpack_public_path__ + "img/T-AS-6_bs_banner_1192x602px.caf6c55b.jpg";